import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'react-bootstrap';
import PropdocsModal from '../../../components/modal/PropdocsModal';
import AddNewDealFormik from '../../../forms/AddNewDealFormContainer';
import { TitleFormattedMessage } from '../../../components/titleFormattedMessage';

interface Props {
  showAddDealModal: boolean;
  onModalHide: () => void;
  currentFolderId?: string | null;
}

const AddNewDealModal = ({ showAddDealModal, onModalHide, currentFolderId }: Props) => {
  // Create containers for the form
  const BodyContainer = ({ children }: { children: React.ReactNode }) => <div>{children}</div>;

  const ActionsContainer = ({ children }: { children: React.ReactNode }) => (
    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem', marginTop: '1rem' }}>{children}</div>
  );

  return (
    <PropdocsModal
      show={showAddDealModal}
      setShow={onModalHide}
      size="sm"
      title={<TitleFormattedMessage id="title.add-team-member" defaultMessage="Create a Deal" />}
    >
      <AddNewDealFormik
        bodyContainer={BodyContainer}
        actionsContainer={ActionsContainer}
        currentFolderId={currentFolderId}
        renderSecondaryAction={() => (
          <Button variant="link" className="text-secondary" onClick={onModalHide}>
            <FormattedMessage id="cta.cancel" defaultMessage="Cancel" />
          </Button>
        )}
      />
    </PropdocsModal>
  );
};

export default AddNewDealModal;
